import { render, staticRenderFns } from "./DocTextField.vue?vue&type=template&id=61d19aa6&scoped=true&"
import script from "./DocTextField.vue?vue&type=script&lang=js&"
export * from "./DocTextField.vue?vue&type=script&lang=js&"
import style0 from "./DocTextField.vue?vue&type=style&index=0&id=61d19aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d19aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VCombobox,VRow,VSelect,VTextField})
